import { Link } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { MarketingLead } from '@/components/marketing/marketing-lead'
import { cn } from '@/lib/utils'

export function CtaBand({
  title,
  lead,
  primaryLabel,
  primaryHref,
  className,
}: {
  title: string
  lead?: string
  primaryLabel: string
  primaryHref: string
  className?: string
}) {
  const isExternal = primaryHref.startsWith('http') || primaryHref.startsWith('mailto:')

  return (
    <section className={cn('marketing-section', className)}>
      <div className="marketing-container">
        <div className="rounded-2xl border border-border bg-gradient-to-b from-card to-card/60 px-6 py-12 text-center md:px-12">
          <h2 className="marketing-h2">{title}</h2>
          {lead ? (
            <MarketingLead className="marketing-lead--center mx-auto mt-4 max-w-2xl">
              {lead}
            </MarketingLead>
          ) : null}
          <div className="mt-8">
            <Button size="lg" asChild>
              {isExternal ? (
                <a href={primaryHref}>{primaryLabel}</a>
              ) : (
                <Link to={primaryHref}>{primaryLabel}</Link>
              )}
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}
